import { createReducer, on } from "@ngrx/store";
import { loadWorkspaceLicenses, loadWorkspaceLicensesFailed, loadWorkspaceLicensesSuccess, resetWorkspaceLicenses, upsertWorkspaceLicenses } from "../actions/workspace-licenses.action";
import { WorkspaceLicensesState, workspaceLicensesInitialState } from "../initial-states/workspace-licenses.state";

export const WorkspaceLicensesReducer = createReducer(workspaceLicensesInitialState,

	// The reducer runs when a dispatch 'loadWorkspaceLicenses' was triggered
	// The only thing we need to do here is to set the loading to true
	on(loadWorkspaceLicenses,
		(state) => ({
			...state,
			licenses: {
				...state.licenses,
				loading: true
			}
		})
	),

	// The reducer runs when a dispatch 'loadWorkspaceLicensesSuccess' was triggered
	// Here we need to set the loading to false, set the value of 'loadedOnce' and add the value of the catalog for the specific type
	on(loadWorkspaceLicensesSuccess,
		(state, { licenses: userLicenses }) => ({
			...state,
			licenses: {
				...state.licenses,
				loading: false,
				loadedOnce: true,
				value: userLicenses
			}
		})
	),

	// The reducer runs when a dispatch 'loadWorkspaceLicensesFailed' was triggered
	// Here we need to set the state to the initial one, set the value of 'loadedOnce' and add the value of the error action result into the store
	on(loadWorkspaceLicensesFailed,
		(state, { error }) => ({
			...state,
			licenses: {
				...state.licenses,
				loading: false,
				loadedOnce: false,
				error: error
			}
		})
	),

	//#region Upsert Workspace Licenses
	/**
	 * Upsert workspace licenses - updates existing licenses or adds new ones.
	 * Matches licenses by 'id' property.
	 */
	on(upsertWorkspaceLicenses,
		(state: WorkspaceLicensesState, { licenses: newLicenses }): WorkspaceLicensesState => {
			const currentLicenses = state.licenses.value ?? [];

			// Create a map of current licenses by id for quick lookup
			const licenseMap = new Map(currentLicenses.map((license: any) => [license.id, license]));

			// Upsert: update existing or add new
			newLicenses.forEach(newLicense => {
				licenseMap.set(newLicense.id, newLicense);
			});

			return {
				...state,
				licenses: {
					...state.licenses,
					value: Array.from(licenseMap.values())
				}
			};
		}
	),
	//#endregion

	// Reset the state to the initial one
	on(resetWorkspaceLicenses, () => ({ ...workspaceLicensesInitialState }) )
)

